import { Phone } from 'lucide-react';
import { StatusHeader } from '@/components';
import type { PhoneLine } from '../api';
import { LineSummary } from './line-summary';
import { NumberPicker } from './number-picker';

interface LineStepProps {
  unitId: string;
  linha: PhoneLine | null;
}

export function LineStep({ unitId, linha }: LineStepProps) {
  if (!linha) {
    return (
      <div className="space-y-5">
        <StatusHeader
          icon={<Phone className="h-5 w-5" />}
          title="Escolher numero"
          detail="Escolha um numero novo no DDD desejado. Nao e necessario ter conta em outro servico."
        />

        <div className="border-t border-border pt-4">
          <NumberPicker unitId={unitId} />
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <LineSummary linha={linha} />

      {linha.openCharge ? (
        <p className="text-xs text-muted-foreground">
          O numero e comprado quando o pagamento e confirmado. Se a compra falhar, nada e cobrado.
        </p>
      ) : (
        <p className="text-xs text-muted-foreground">
          A proxima cobranca aparece aqui uma semana antes de vencer.
        </p>
      )}
    </div>
  );
}
